var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{},[(_vm.hasSchedule)?_c('CalendarIcon',{attrs:{"width":"20"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }